import { Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { getLangDir } from "@/lib/i18n";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import TrialBanner from "@/components/shared/TrialBanner";
import DemoBanner from "@/components/shared/DemoBanner";
import { ShieldCheck } from "lucide-react";

export default function DashboardLayout() {
  const { language, i18n } = useAuth();
  const dir = getLangDir(language);

  return (
    <div className="flex h-screen overflow-hidden bg-[#020617]" dir={dir} data-testid="dashboard-layout">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <TopBar />
        <DemoBanner />
        <TrialBanner />
        <div className="mx-4 md:mx-6 lg:mx-8 mt-1 flex items-center gap-1.5 px-3 py-1 rounded-md bg-slate-900/30 border border-slate-800/20" data-testid="trust-banner">
          <ShieldCheck className="w-3 h-3 text-emerald-500/60 shrink-0" />
          <span className="text-[9px] text-slate-600 font-manrope">{i18n("trust.banner")}</span>
        </div>
        <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
